import { render } from "./SymbolList.vue?vue&type=template&id=bdde36ee&scoped=true&ts=true"
import script from "./SymbolList.vue?vue&type=script&lang=ts"
export * from "./SymbolList.vue?vue&type=script&lang=ts"

import "./SymbolList.vue?vue&type=style&index=0&id=bdde36ee&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdde36ee"]])

export default __exports__